import { fetcher } from '@common/utils/fetcher';

export type Advertising = {
  ad: {
    id: number;
    title: string;
    description: string;
    action_text: string;
    action_link: string;
    picture_url: string;
  };
};

type FeedAdView = {
  view_id: number;
};

export type GetFeedAdResponse = Advertising;
export type PostFeedAdViewByIdParams = {
  id: number;
};

export type PostFeedAdViewByIdResponse = FeedAdView;

export type PostFeedAdViewClickByIdParams = {
  id: number;
};

export type PostFeedAdViewClickByIdResponse = null;

export const getFeedAd = () => {
  return fetcher<GetFeedAdResponse>({
    url: '/feed-ad',
    method: 'GET',
  });
};

export const postFeedAdViewById = ({ id }: PostFeedAdViewByIdParams) => {
  return fetcher<PostFeedAdViewByIdResponse>({
    url: `/feed-ad/${id}/view`,
    method: 'POST',
  });
};

export const postFeedAdViewClickById = ({
  id,
}: PostFeedAdViewClickByIdParams) => {
  return fetcher<PostFeedAdViewClickByIdResponse>({
    url: `/feed-ad/view/${id}/click`,
    method: 'POST',
  });
};
